module.exports = __webpack_public_path__ + "static/media/Jacob Kowalski 3.689b1542.jpg";